import { normalizePro20Response } from '@/shared/api/pro20-transform';

import type { PublicRelation } from '../types/public-relation.types';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function hasContentArray(
  value: unknown,
): value is { content: unknown[] } {
  return isRecord(value) && Array.isArray(value.content);
}

export function normalizePublicRelation(raw: unknown): PublicRelation | null {
  if (!isRecord(raw)) {
    return null;
  }

  const prId = Number(raw.prId);
  if (!Number.isFinite(prId)) {
    return null;
  }

  return {
    prId,
    branchCode: typeof raw.branchCode === 'string' ? raw.branchCode : '',
    prName: typeof raw.prName === 'string' ? raw.prName : '',
  };
}

export function normalizePublicRelationsList(raw: unknown): PublicRelation[] {
  const results = normalizePro20Response(raw);

  if (hasContentArray(results)) {
    return results.content
      .map((item) => normalizePublicRelation(item))
      .filter((item): item is PublicRelation => item !== null);
  }

  if (Array.isArray(results)) {
    return results
      .map((item) => normalizePublicRelation(item))
      .filter((item): item is PublicRelation => item !== null);
  }

  const single = normalizePublicRelation(results);
  return single ? [single] : [];
}
